export default "__VITE_ASSET__BrzuAvcB__"